import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-coverage-tooltip',
  templateUrl: './coverage-tooltip.component.html',
  standalone: false,
})
export class CoverageTooltipComponent {
  @Input() title?: string = '';
  @Input() description?: string = '';
  @Input() amount?: number = 0;
}
